export function mapBBoxTitleToFormType(title: string): string | null {
  const normalized = title.toLowerCase();

  if (normalized.includes('procedure') || normalized.includes('surgery'))
    return 'Surgeries';
  if (normalized.includes('imaging') || normalized.includes('test'))
    return 'Imaging and Tests';
  if (normalized.includes('condition')) return 'Medical Conditions';
  if (normalized.includes('immunization')) return 'Immunizations';
  if (normalized.includes('allergy')) return 'Allergies';
  // Must match the RESOURCE_FORM_MAP / RESOURCE_CURATION_CONFIG key exactly,
  // or the side-by-side curation view can never resolve the form component.
  if (normalized.includes('vital')) return 'Vital Sign';
  if (normalized.includes('appointment')) return 'Appointment';
  if (normalized.includes('hospital')) return 'Hospitalizations';
  if (normalized.includes('emergency')) return 'Emergency Visits';
  if (normalized.includes('lab')) return 'Lab Results';
  if (normalized.includes('genetic')) return 'Genetic Information';
  if (normalized.includes('family')) return 'Family History';
  if (normalized.includes('medicationstatement')) return 'Medications';
  if (normalized.includes('insurance')) return 'Insurance';
  if (normalized.includes('body')) return 'Body';
  if (normalized.includes('location')) return null; // skip facility metadata

  return null;
}

export function mapResourceTypeToHeading(title: string): string | null {
  const normalized = title.toLowerCase();

  if (normalized.includes('procedure') || normalized.includes('surgeries'))
    return 'Surgery';
  if (normalized.includes('imaging') || normalized.includes('test'))
    return 'Imaging & Test';
  if (normalized.includes('condition')) return 'Medical Condition';
  if (normalized.includes('immunization')) return 'Immunization';
  if (normalized.includes('allergy') || normalized.includes('allergies'))
    return 'Allergy';
  if (normalized.includes('vital')) return null;
  if (normalized.includes('appointment')) return 'Appointment';
  if (normalized.includes('hospital')) return 'Hospitalization';
  if (normalized.includes('emergency')) return 'Emergency Visit';
  if (normalized.includes('lab')) return null;
  if (normalized.includes('genetic')) return 'Genetic Information';
  if (normalized.includes('family')) return 'Family History';
  if (normalized.includes('insurance')) return 'Insurance';
  if (normalized.includes('body')) return 'Body';
  if (normalized.includes('medication')) return 'Medication';

  return null;
}

export function mapToAttachmentName(title: string): string | null {
  const normalized = title.toLowerCase();

  if (normalized.includes('procedure') || normalized.includes('surgeries'))
    return 'surgery';
  if (normalized.includes('imaging') || normalized.includes('test'))
    return 'imaging';
  if (normalized.includes('condition')) return 'medicalcondition';
  if (normalized.includes('immunization')) return 'immunization';
  if (normalized.includes('allergy') || normalized.includes('allergies'))
    return 'allergy';
  if (normalized.includes('vital')) return 'vitalsigns';
  if (normalized.includes('appointment')) return 'appointment';
  if (normalized.includes('hospital')) return 'hospitalization';
  if (normalized.includes('emergency')) return 'emergency';
  if (normalized.includes('lab')) return 'labs';
  if (normalized.includes('genetic')) return 'geneticinformation';
  if (normalized.includes('family')) return 'familyhistory';
  if (normalized.includes('insurance')) return 'insurance';
  if (normalized.includes('body')) return 'body';
  if (normalized.includes('medication')) return 'medication';

  return null;
}
